module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "preview-form"
    }
  }, [_c('div', {
    staticClass: "row preview-form-parent justify-content-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row show-form-parent justify-content-center no-gutters"
  }, [_c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "row justify-content-center no-gutters"
  }, [_c('div', {
    staticClass: "col-10 col-sm-10 col-md-8 show-form"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end mr-30 mt-10"
  }, [_c('span', {
    staticClass: "text-right"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/assets/images/flag/en.png"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLang('en')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/assets/images/flag/fr.png"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLang('fr')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row image-div-row"
  }, [_c('div', {
    staticClass: "col-10 col-sm-11 col-md-11 image-div center-block"
  }, [_c('img', {
    staticClass: "form-image",
    attrs: {
      "src": _vm.form.image,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row rental-name"
  }, [_c('div', {
    staticClass: "col-8 center-block text-align-center"
  }, [_c('p', [_vm._v(_vm._s(_vm.rentalName))])])]), _vm._v(" "), (_vm.form.type.name === 'welcome') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 center-block text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.form.description))])])]) : _vm._e(), _vm._v(" "), (_vm.form.type.name === 'welcome') ? _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "col-12 preview-ul"
  }, _vm._l((_vm.form.fields), function(field, index) {
    return _c('li', {
      staticClass: "form-fields form-line"
    }, [(field.type.name == 'input' && field.element.name == 'text') ? _c('div', {
      staticClass: "row form-group form-material"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                                          " + _vm._s(field.label) + "\n                                                          "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]['value']),
        expression: "inputs[field.model]['value']"
      }],
      staticClass: "form-control border-0",
      attrs: {
        "id": field.type.name + index,
        "type": "text",
        "required": field.mandatory == 1,
        "disabled": (field.reference && (field.reference.name == 'checking' || field.reference.name == 'checkout')) && !_vm.auth
      },
      domProps: {
        "value": (_vm.inputs[field.model]['value'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.inputs[field.model], 'value', $event.target.value)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (field.type.name == 'input' && (field.element.name == 'email' || field.element.name == 'password')) ? _c('div', {
      staticClass: "row form-group form-material"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                                        " + _vm._s(field.label) + "\n                                                        "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), ((field.element.name) === 'checkbox') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]['value']),
        expression: "inputs[field.model]['value']"
      }],
      staticClass: "form-control border-0",
      attrs: {
        "id": field.type.name + index,
        "required": field.mandatory == 1,
        "disabled": (field.reference && (field.reference.name == 'checking' || field.reference.name == 'checkout')) && !_vm.auth,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.inputs[field.model]['value']) ? _vm._i(_vm.inputs[field.model]['value'], null) > -1 : (_vm.inputs[field.model]['value'])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.inputs[field.model]['value'],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.inputs[field.model], 'value', $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.inputs[field.model], 'value', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.inputs[field.model], 'value', $$c)
          }
        }
      }
    }) : ((field.element.name) === 'radio') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]['value']),
        expression: "inputs[field.model]['value']"
      }],
      staticClass: "form-control border-0",
      attrs: {
        "id": field.type.name + index,
        "required": field.mandatory == 1,
        "disabled": (field.reference && (field.reference.name == 'checking' || field.reference.name == 'checkout')) && !_vm.auth,
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.inputs[field.model]['value'], null)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.inputs[field.model], 'value', null)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]['value']),
        expression: "inputs[field.model]['value']"
      }],
      staticClass: "form-control border-0",
      attrs: {
        "id": field.type.name + index,
        "required": field.mandatory == 1,
        "disabled": (field.reference && (field.reference.name == 'checking' || field.reference.name == 'checkout')) && !_vm.auth,
        "type": field.element.name
      },
      domProps: {
        "value": (_vm.inputs[field.model]['value'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.inputs[field.model], 'value', $event.target.value)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (field.type.name == 'input' && (field.element.name == 'checkbox' || field.element.name == 'radio')) ? _c('div', {
      staticClass: "row form-group form-material"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('label', {
      staticClass: "control-label form-label form-label-left form-label-auto",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                                        " + _vm._s(field.label) + "\n                                                        "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _vm._l((field.select_options), function(option, i) {
      return _c('div', {
        staticClass: "options"
      }, [((field.element.name) === 'checkbox') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.inputs[field.model]['value']),
          expression: "inputs[field.model]['value']"
        }],
        attrs: {
          "id": field.type.name + i,
          "name": option.label,
          "required": field.mandatory == 1,
          "disabled": (field.reference && (field.reference.name == 'checking' || field.reference.name == 'checkout')) && !_vm.auth,
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(_vm.inputs[field.model]['value']) ? _vm._i(_vm.inputs[field.model]['value'], null) > -1 : (_vm.inputs[field.model]['value'])
        },
        on: {
          "change": function($event) {
            var $$a = _vm.inputs[field.model]['value'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.inputs[field.model], 'value', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.inputs[field.model], 'value', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.inputs[field.model], 'value', $$c)
            }
          }
        }
      }) : ((field.element.name) === 'radio') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.inputs[field.model]['value']),
          expression: "inputs[field.model]['value']"
        }],
        attrs: {
          "id": field.type.name + i,
          "name": option.label,
          "required": field.mandatory == 1,
          "disabled": (field.reference && (field.reference.name == 'checking' || field.reference.name == 'checkout')) && !_vm.auth,
          "type": "radio"
        },
        domProps: {
          "checked": _vm._q(_vm.inputs[field.model]['value'], null)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.inputs[field.model], 'value', null)
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.inputs[field.model]['value']),
          expression: "inputs[field.model]['value']"
        }],
        attrs: {
          "id": field.type.name + i,
          "name": option.label,
          "required": field.mandatory == 1,
          "disabled": (field.reference && (field.reference.name == 'checking' || field.reference.name == 'checkout')) && !_vm.auth,
          "type": field.element.name
        },
        domProps: {
          "value": (_vm.inputs[field.model]['value'])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.inputs[field.model], 'value', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "control-label",
        attrs: {
          "for": field.type.name + index
        }
      }, [_vm._v("\n                                                            " + _vm._s(option.name) + "\n                                                        ")])])
    })], 2)]) : _vm._e(), _vm._v(" "), (field.type.name == 'input' && field.element.name == 'time' && field.model == 'time_in') ? _c('div', {
      staticClass: " form-group form-material"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("\n                                                        " + _vm._s(field.label) + "\n                                                        "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]['value']),
        expression: "inputs[field.model]['value']"
      }],
      staticClass: "form-control",
      attrs: {
        "required": field.mandatory == 1
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.inputs[field.model], 'value', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.timeInHours), function(i) {
      return _c('option', {
        domProps: {
          "value": i
        }
      }, [_vm._v(_vm._s(i))])
    }))])])]) : _vm._e(), _vm._v(" "), (field.type.name == 'input' && field.element.name == 'time' && field.model == 'time_out') ? _c('div', {
      staticClass: " form-group form-material"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("\n                                                      " + _vm._s(field.label) + "\n                                                      "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]['value']),
        expression: "inputs[field.model]['value']"
      }],
      staticClass: "form-control",
      attrs: {
        "required": field.mandatory == 1
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.inputs[field.model], 'value', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.timeOutHours), function(i) {
      return _c('option', {
        domProps: {
          "value": i
        }
      }, [_vm._v(_vm._s(i))])
    }))])])]) : _vm._e(), _vm._v(" "), (field.type.name == 'input' && field.element.name == 'date') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("\n                                                          " + _vm._s(field.label) + "\n                                                          "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('datepicker', {
      staticClass: "form-control",
      attrs: {
        "id": "check-in",
        "format": "dd D MMMM yyyy",
        "language": _vm.language,
        "disabled-picker": true
      },
      model: {
        value: (field.model == 'checking' ? _vm.checkinDate : field.model == 'checkout' ? _vm.checkoutDate : ''),
        callback: function($$v) {
          _vm.$set(field.model == 'checking' ? _vm.checkinDate : field, "model == 'checkout' ? checkoutDate : ''", $$v)
        },
        expression: "field.model == 'checking' ? checkinDate : field.model == 'checkout' ? checkoutDate : ''"
      }
    })], 1)])]) : _vm._e(), _vm._v(" "), (field.type.name == 'select') ? _c('div', {
      staticClass: "row form-group form-material"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                                        " + _vm._s(field.label) + "\n                                                        "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]['value']),
        expression: "inputs[field.model]['value']"
      }],
      staticClass: "form-control border-0",
      attrs: {
        "id": "field.type.name+index",
        "required": field.mandatory === 1,
        "disabled": (field.reference && (field.reference.name == 'checking' || field.reference.name == 'checkout')) && !_vm.auth
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.inputs[field.model], 'value', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('input.please_select')) + _vm._s(field.label))]), _vm._v(" "), _vm._l((field.select_options), function(option, i) {
      return _c('option', {
        attrs: {
          "id": field.type.name + i,
          "type": field.element.name,
          "name": option.label,
          "required": field.mandatory == 1
        }
      }, [_vm._v("\n                                                            " + _vm._s(option.name) + "\n                                                        ")])
    })], 2)])])]) : _vm._e(), _vm._v(" "), (field.type.name == 'textarea') ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                                        " + _vm._s(field.label) + "\n                                                        "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {}, [_c('span', {
      staticClass: "form-sub-label-container",
      staticStyle: {
        "vertical-align": "top"
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]['value']),
        expression: "inputs[field.model]['value']"
      }],
      staticClass: "form-control",
      attrs: {
        "id": field.label + index,
        "name": "",
        "cols": "100",
        "rows": "6",
        "data-component": "textarea",
        "required": field.mandatory == 1,
        "disabled": field.reference && (field.reference.name == 'checking' || field.reference.name == 'checkout')
      },
      domProps: {
        "value": (_vm.inputs[field.model]['value'])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.inputs[field.model], 'value', $event.target.value)
        }
      }
    })])])]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row buttons-row"
  }, [_c('div', {
    staticClass: "m-auto"
  }, [_c('button', {
    staticClass: "btn send-button",
    attrs: {
      "id": "clear-form",
      "type": "reset"
    }
  }, [_vm._v("\n                                              " + _vm._s(_vm.$t('button.clear_form')) + "\n                                          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-red send-button",
    attrs: {
      "id": "submit",
      "type": "submit"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('button.submit')) + "\n                                          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.form.type.name === 'checkin') ? _c('v-checkin-form', {
    attrs: {
      "booking": _vm.booking,
      "form": _vm.form,
      "timeInHours": _vm.timeInHours,
      "timeOutHours": _vm.timeOutHours,
      "steps": _vm.stepCount
    },
    on: {
      "getBooking": _vm.getBookingByPermalink
    }
  }) : _vm._e()], 1)])])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4497aeb8"}!./src/app/pages/form/show/show.html
// module id = 1361
// module chunks = 0